//// TOOLBAR IMPORTS  ////
import {
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { MenuItem, Tooltip, IconButton } from '@mui/material';
//PDF IMPORTS //
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { gridVisibleColumnFieldsSelector, gridFilteredSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
// APP IMPORS //
import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';
import { Create, RestartAlt, DeleteForever, Close } from '@mui/icons-material';
import { Link } from 'react-router-dom';

//////////// CUSTOM TOOLBAR  //////////////////////////
function CustomToolBar({ open, csvOptions, rows, printOptions, ColDef, ...other }, props) {
  return (
    <div className="d-flex justify-content-between">
      <div>
        {/**All the other toolbar options we want */}
        <GridToolbarColumnsButton />
        {/* <GridToolbarFilterButton /> */}
        <GridToolbarDensitySelector />
        {/**THis is the export drop down */}
        <GridToolbarExportContainer {...other}>
          <GridCsvExportMenuItem options={csvOptions} />
          {/*}<GridPrintExportMenuItem options={printOptions} />*/}
          {/*<GridExportPDF options={props} />*/}
          <ExportExcel options={props} />
        </GridToolbarExportContainer>
      </div>
      <GridToolbarQuickFilter />
    </div>
  );
}

////////// PDF OPTION //////////////////////////
function GridExportPDF() {
  // A built in MUI hook for getting the state of the current table
  const apiRef = useGridApiContext();
  const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);

  // Format the data. Incase the user has hidden some columns in the data grid
  const data = filteredSortedRowIds.map((id) => {
    const row = {};
    visibleColumnsField.forEach((field) => {
      if (field !== 'actions') {
        row[field] = apiRef.current.getCellParams(id, field).value;
      }
    });
    return row;
  });

  // Functions to export the data to pdf
  const exportPDF = async () => {
    const unit = 'pt';
    const size = 'A4'; // Use A1, A2, A3 or A4
    const orientation = 'portrait'; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    // Set the font size
    doc.setFontSize(15);

    // name of the PDF doc at the top
    const title = 'Data Export';

    // Dynamically get all the headers for the table from the data
    const headers = [Object.keys(data[0]).map((e) => e)];

    // Get the rows for the PDF
    const pdfData = data.map((e) => Object.values(e).map((x) => x));

    // The content of the PDF
    let content = {
      startY: 50,
      head: headers,
      body: pdfData,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    // The name of the document
    doc.save('tableDownload.pdf');
  };
  return <MenuItem onClick={exportPDF}>PDF</MenuItem>;
}

export function ExportExcel() {
  // const newData=studentData.map(row=>{
  //   delete row.tableData
  //   return row
  // })
  // A built in MUI hook for getting the state of the current table
  const apiRef = useGridApiContext();
  const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);
  // Get all column definitions to map field names to header names
  const columns = apiRef.current.getAllColumns();

  const data = filteredSortedRowIds.map((id) => {
    const row = {};
    visibleColumnsField.forEach((field) => {
      if (field !== 'actions') {
        // Find the column definition to get the headerName
        const column = columns.find((col) => col.field === field);
        const headerName = column?.headerName || field;
        row[headerName] = apiRef.current.getCellParams(id, field).value;
      }
    });
    return row;
  });

  function download() {
    const workSheet = XLSX.utils.json_to_sheet(data);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'tableData');
    //Buffer
    let buf = XLSX.write(workBook, { bookType: 'xlsx', type: 'buffer' });
    //Binary string
    XLSX.write(workBook, { bookType: 'xlsx', type: 'binary' });
    //Download
    XLSX.writeFile(workBook, 'tableData.xlsx');
  }

  return <MenuItem onClick={download}>Download as Excel</MenuItem>;
}

//////////// TABLE //////////////////////////

export default function CustomTable({ actions, ...p }) {
  const [sortModel, setSortModel] = React.useState(p.sortModel);
  let columnActions = {};
  if (actions) {
    columnActions = {
      field: 'actions',
      headerName: '',
      headerAlign: 'center',
      // flex: actions.flex,
      width: actions.width ? actions.width : actions.toggleDelete || actions.link ? 130 : 100,
      disableExport: true,
      renderCell: ({ row }) => {
        return (
          <div className="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }}>
            {actions.custom && <actions.custom row={row} />}
            {actions.toggleEdit && (
              <IconButton onClick={() => actions.toggleEdit(row)}>
                <Tooltip title={'Edit'} placement="top">
                  <Create style={{ color: '#0E4BD9' }} />
                </Tooltip>
              </IconButton>
            )}

            {actions.toggleDelete && (
              <IconButton onClick={() => actions.toggleDelete(row)}>
                <Tooltip title="Delete Forever" placement="top">
                  <DeleteForever style={{ color: '#bc3c51' }} />
                </Tooltip>
              </IconButton>
            )}

            {actions.link && (
              <IconButton>
                <Tooltip title={actions.link.toolTip || ''} placement="top">
                  <Link style={{ fontSize: '18px', lineHeight: '14px' }} to={actions.link.getLink(row)}>
                    {actions.link.icon}
                  </Link>
                </Tooltip>
              </IconButton>
            )}

            {actions.toggleActive && (
              <IconButton onClick={() => actions.toggleActive(row)}>
                <Tooltip title={row.is_active ? 'Deactivate' : 'Activate'} placement="top">
                  {row.is_active ? <Close style={{ color: '#bc3c51' }} /> : <RestartAlt style={{ color: '#28a745' }} />}
                </Tooltip>
              </IconButton>
            )}
            {/**Pass a custom component here */}
          </div>
        );
      },
    };
  }

  const columns = actions ? [columnActions, ...p.columns] : p.columns;
  return (
    <DataGrid
      autoHeight
      paginationMode="server"
      rows={p.rows}
      columns={columns}
      sortModel={sortModel}
      pageSize={p.pageSize}
      onSortModelChange={(model) => setSortModel(model)}
      loading={p.loading}
      onPageSizeChange={(size) => p.setPageSize(size)}
      onPageChange={(pg) => p.setPage(++pg)}
      rowCount={p.rowCount}
      getRowId={p.getRowId ? p.getRowId : (row) => row.id}
      rowsPerPageOptions={[10, 20, 50, 100]}
      components={{
        Toolbar: CustomToolBar,
      }}
      componentsProps={{
        toolbar: {
          open: () => {},
          csvOptions: { allColumns: false },
        },
      }}
      disableSelectionOnClick
      experimentalFeatures={{ newEditingApi: true }}
      classes={{ footerCell: { backgroundColor: 'black' } }}
    />
  );
}
